export const RECEIVE_MESSAGE = "ReceiveMessage";
export const JOIN_ROOM = "JoinRoom";
export const SEND_MESSAGE = "SendMessageToActiveRoom";
export const SET_ACTIVE_ROOM = "SetActiveRoom";
export const SEND_CONNECTED_USERS = "SendConnectedUsers";
export const JOIN_ROOMS = "JoinRooms";
export const SEND_CONNECTED_ROOMS = "SendConnectedRooms";